import { USER_SETTINGS_STORAGE_PREFIX } from '@wix/wix-data-client-common'
import { userSettingsStorage } from '@wix/wix-data-client-common/dist/esm/infra/userSettingsStorage'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import type Experiments from '@wix/wix-experiments'

const isKeyAlreadySet = async (
  key: string,
  options: { scope?: string } = {},
): Promise<boolean> => {
  let keyExists

  try {
    keyExists = await userSettingsStorage.getItem(key, options)
  } catch {
    keyExists = false
  }

  return Boolean(keyExists)
}

const FIRST_TIME_CONVERSION_BANNER = 'first-time-conversion-banner'

const getSettingsStorageParams = (
  metaSiteId: string,
  userId: string,
  experimentsManager: Experiments,
) => {
  if (
    experimentsManager.enabled('specs.wixCode.CMSWebUserPreferencesMigration')
  ) {
    return {
      key: FIRST_TIME_CONVERSION_BANNER,
      options: { scope: metaSiteId },
    }
  }

  return {
    key: `${USER_SETTINGS_STORAGE_PREFIX}_${metaSiteId}_${userId}_${FIRST_TIME_CONVERSION_BANNER}`,
    options: {},
  }
}

export const handleFirstTimeDpConversion = async (
  collectionId: string,
  editorSdkProxy: EditorSDK,
  experimentsManager: Experiments,
) => {
  const [metaSiteId, userId] = await Promise.all([
    editorSdkProxy.info.getMetaSiteId(),
    editorSdkProxy.info.getUserId(),
  ])

  const { key, options } = getSettingsStorageParams(
    metaSiteId,
    userId,
    experimentsManager,
  )

  if (await isKeyAlreadySet(key, options)) {
    return
  }

  try {
    await userSettingsStorage.setItem(
      key,
      {
        acknowledged: false,
        collectionId,
      },
      options,
    )
  } catch {}
}
